export default __webpack_public_path__ + "static/og-image-d15ea120fc30922101c4608dba47729b.jpg";